"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
var redux_persist_1 = require("redux-persist");
var server_1 = require("../../helpers/server");
var initialState = {
    isLoading: false,
    companies: [],
};
var SettingsReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case (0, server_1.apiActions)(actions_1.Actions.COMPANY_LIST).request:
            return __assign(__assign({}, state), { isLoading: true });
        case (0, server_1.apiActions)(actions_1.Actions.COMPANY_LIST).success:
            return __assign(__assign({}, state), { isLoading: false, companies: action.payload });
        case (0, server_1.apiActions)(actions_1.Actions.COMPANY_LIST).fail:
            return __assign({}, state);
        case (0, server_1.apiActions)(actions_1.Actions.COMPANY_UPDATE).request:
            return __assign(__assign({}, state), { isLoading: true });
        case (0, server_1.apiActions)(actions_1.Actions.COMPANY_UPDATE).success:
            var companies = getUpdatedCompanies(state.companies, action.payload.company);
            return __assign(__assign({}, state), { isLoading: false, companies: companies });
        case (0, server_1.apiActions)(actions_1.Actions.COMPANY_UPDATE).fail:
            return __assign(__assign({}, state), { isLoading: false });
        case redux_persist_1.PURGE:
            return __assign({}, initialState);
        default: return state;
    }
};
var getUpdatedCompanies = function (companies, company) {
    var index = companies.findIndex(function (item) {
        return item._id === company._id;
    });
    var updatedCompanies = JSON.parse(JSON.stringify(companies));
    updatedCompanies[index] = company;
    return updatedCompanies;
};
exports.default = SettingsReducer;
